module.exports = __webpack_public_path__ + "img/center-info-structure1-2.dee559cf.png";